import { AlertDialogBody, AlertDialogFooter } from '@chakra-ui/react'

import { BasicAlertDialog, Button } from '@/components/ui'

interface SaveGridConfirmDialogIProps {
  isOpen: boolean
  isSaving: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const SaveGridConfirmDialog = ({
  isOpen,
  isSaving,
  onCancel,
  onConfirm,
}: SaveGridConfirmDialogIProps) => (
  <BasicAlertDialog
    isCentered
    isOpen={isOpen}
    onClose={onCancel}
    title='Save New Camera Grid?'
  >
    <AlertDialogBody>
      This will replace the current grid configuration for this camera with the
      one you just tested. This action cannot be undone.
    </AlertDialogBody>
    <AlertDialogFooter>
      <Button mr={3} onClick={onCancel} variant='secondary'>
        Cancel
      </Button>
      <Button isDisabled={isSaving} onClick={onConfirm}>
        Save Grid
      </Button>
    </AlertDialogFooter>
  </BasicAlertDialog>
)
